<template>
    <div class="p-3">
        <p class="text-muted small mb-3">
            <b-icon icon="info-circle"></b-icon> Webhooks recebidos cuja oferta não existe mais no ERP.
        </p>

        <!-- lista completa vem por prop: a diretiva cuida da busca, ordenação e paginação no navegador -->
        <div class="table-responsive">
            <table v-ec-datatable class="table table-sm table-hover ec-tabela mb-0">
                <thead class="ec-thead">
                    <tr>
                        <th class="text-left">Inscrito</th>
                        <th>Webhook</th>
                        <th>Cód. oferta CRM</th>
                        <th class="text-left">Tipo</th>
                        <th>Sincronização</th>
                        <th>Origem</th>
                        <th>Recebido em</th>
                    </tr>
                </thead>
                <tbody v-if="webhooks && webhooks.length>0">
                    <tr v-for="aluno_captado in webhooks" :key="aluno_captado.id">
                        <td class="text-left" data-label="Inscrito">
                            <span class="ec-tabela__principal">
                                <template v-if="aluno_captado.nomeinscrito">{{ aluno_captado.nomeinscrito }}</template>
                                <span v-else class="ec-tabela__vazio">—</span>
                            </span>
                            <small class="ec-tabela__secundario">Contato CRM {{ aluno_captado.contatoid || '—' }}</small>
                        </td>
                        <td data-label="Webhook">
                            <span class="ec-tabela__principal">{{ aluno_captado.id }}</span>
                        </td>
                        <td data-label="Cód. oferta CRM">
                            <span v-if="aluno_captado.codigooferta">{{ aluno_captado.codigooferta }}</span>
                            <span v-else class="ec-tabela__vazio">—</span>
                        </td>
                        <td class="text-left" data-label="Tipo">
                            <span class="ec-status ec-status--rotulo ec-status--info">{{ ( aluno_captado.tipoeventoaviso=='c' ? "Insc. Confirmada" : ( aluno_captado.tipoeventoaviso=='a' ? "Contrato Assinado" : ( aluno_captado.tipoeventoaviso=='m' ? "Matriculado":( aluno_captado.tipoeventoaviso=='v' ? "Envia Valor CRM":( aluno_captado.tipoeventoaviso=='f' ? "Atualização Cadastral":( aluno_captado.tipoeventoaviso=='d' ? "Documentos":"Outros" ) ) ) ) ) ) }}</span>
                        </td>
                        <td data-label="Sincronização">
                            <span v-if="aluno_captado.processado == 1" class="ec-status ec-status--sucesso">Sincronizado</span>
                            <span v-else class="ec-status ec-status--aviso">Pendente</span>
                        </td>
                        <td data-label="Origem">
                            <span v-if="aluno_captado.origem_inclusao" class="ec-status ec-status--rotulo ec-status--neutro">{{ aluno_captado.origem_inclusao }}</span>
                            <span v-else class="ec-tabela__vazio">—</span>
                        </td>
                        <td data-label="Recebido em">
                            <span class="ec-tabela__principal font-weight-normal">{{ daraHoraBrasileiro(aluno_captado.created_at) }}</span>
                            <small class="ec-tabela__secundario">Atualizado {{ daraHoraBrasileiro(aluno_captado.updated_at) }}</small>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="7" class="ec-tabela__estado">
                            <b-icon icon="inbox" font-scale="2"></b-icon>
                            <p>A lixeira está vazia: nenhum webhook com oferta inexistente no ERP.</p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props:['usuarioLogado','webhooks'],
    data(){
        return{
            captados_webhook:[],
            lista_web_hook:[],
            web_hook_assinados:[],
            web_hook_matriculados:[],
            web_hook_valormatricula:[],
            filtro:{
                tipoeventoaviso:0,
                nome_inscrito:null,
                contatoid:null,
                webhook_id:null,
                sincronizado:null
            },
            url_webhooks:'/api/v1/Crm/getWebHooksUnity/',
            url_search:'/api/v1/Crm/searchWebHooksUnity/',
            complemento_url:"",
        }
    },
    methods:{
        daraHoraBrasileiro(date){
            let dataHora = new Date(date)
            // let dataHoraUtc = new Date()
            return dataHora.toLocaleString('pt-BR', { timezone: 'UTC' })
        }
    },
    created(){
        // this.captados_webhook = this.webHooks;
        // console.log(this.captados_webhook);
        // this.url_webhooks = this.url_webhooks+this.unitie.id
        // this.url_search = this.url_search+this.unitie.id
        
    },
    mounted(){
        // this.getWebHooksUnity();
    }
}
</script>
